module.exports = require("@material-ui/icons/FullscreenExit");